import { render, staticRenderFns } from "./communityManagement.vue?vue&type=template&id=1fe3d748&scoped=true&"
import script from "./communityManagement.vue?vue&type=script&lang=js&"
export * from "./communityManagement.vue?vue&type=script&lang=js&"
import style0 from "./communityManagement.vue?vue&type=style&index=0&id=1fe3d748&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe3d748",
  null
  
)

export default component.exports